import React, { useEffect } from 'react';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Header from '../../layout/Header.jsx';
import FormConfig from '../../forms/FormConfig.jsx';

const PageConfig = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: '/api/site/configs',
    });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header>
            Settings
          </Header>
          <FormConfig config={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PageConfig;
